import {z} from 'zod';

export const memberDestinationSchema = z.enum(['legacy', 'modern']);
export type MemberDestination = z.infer<typeof memberDestinationSchema>;
